// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.proofOfIncome.landing.modal.';

const PROOF_INCOME_LANDING_MODAL_FEATURE_01_OPENBANKING = `${DOMAIN}description.openBankingFeature01`,
  PROOF_INCOME_LANDING_MODAL_FEATURE_01_TGSS = `${DOMAIN}description.TGSSFeature01`,
  PROOF_INCOME_LANDING_MODAL_FEATURE_02_OPENBANKING = `${DOMAIN}description.openBankingFeature02`,
  PROOF_INCOME_LANDING_MODAL_FEATURE_02_TGSS = `${DOMAIN}description.TGSSFeature02`,
  PROOF_INCOME_LANDING_MODAL_FEATURE_03_OPENBANKING = `${DOMAIN}description.openBankingFeature03`,
  PROOF_INCOME_LANDING_MODAL_FEATURE_03_TGSS = `${DOMAIN}description.TGSSFeature03`;

export {
  PROOF_INCOME_LANDING_MODAL_FEATURE_01_OPENBANKING,
  PROOF_INCOME_LANDING_MODAL_FEATURE_01_TGSS,
  PROOF_INCOME_LANDING_MODAL_FEATURE_02_OPENBANKING,
  PROOF_INCOME_LANDING_MODAL_FEATURE_02_TGSS,
  PROOF_INCOME_LANDING_MODAL_FEATURE_03_OPENBANKING,
  PROOF_INCOME_LANDING_MODAL_FEATURE_03_TGSS,
};
